import { permissionsData } from './list'

export const allPermissions = permissionsData.sort(
    (previous, current) => previous.id - current.id,
)
